/**
 * This component renders the top banner for a Single Club Page
 *
 */

import React from "react";
import ImageContainer from "../core/ImageContainer";
import TabButton from "../core/TabButton";
import TabButtonDropdown from "../core/TabButtonDropdown";

const ClubBanner = ({
  gbu,
  activeTab,
  handleTabClick,
  name,
  col1,
  col2,
  img,
  home,
  founded,
  members = 0,
  fb,
  tw,
  ig,
  yt,
  news,
  web,
}) => {
  // Define gradient style using col1 and col2
  const gradientStyle =
  col1 && col2
    ? { background: `linear-gradient(to right, ${col1}, ${col2})` }
    : {};

  // Define tabs
  const allTabs = [{ tabName: "about", label: "About", first: true }];

  if (gbu) {
    if (news > 0) {
      allTabs.push({
        tabName: "news",
        label: "News",
      });
    }
  } else {
    allTabs.push(
      { tabName: "roster", label: "Roster" },
      { tabName: "schedule", label: "Schedule" },
      { tabName: "standings", label: "Tables" },
      { tabName: "stats", label: "Stats" }
    );

    if (news > 0) {
      allTabs.push({
        tabName: "news",
        label: "News",
      });
    }
  }
  let visibleTabs;
  if (allTabs.length > 4) {
    visibleTabs = allTabs.slice(0, 3);
  } else {
    visibleTabs = allTabs.slice(0, 4);
  }
  const overflowTabs = allTabs.slice(3);

  return (
    <div
      className="w-full homegradient border-b-2 border-light-3 dark:border-dark-3"
      style={gradientStyle}
    >
      <div className="flex flex-row justify-between items-center border-1 border-white rounded-lg">
        <div className="flex flex-col w-full justify-between items-left border-1 border-blue">
          <div className="flex flex-row w-full max-lg2:justify-center max-lg2:items-center lg2:justify-left lg2:items-left border-1 py-1 border-black">
            {/* Club logo */}
            {img?.lg ? (
                <img
                    src={img.lg}
                    alt={name}
                    className="md:h-48 md:w-48 xxs:h-40 xxs:w-40 h-32 w-32 max-lg2:mr-4 bannerL"
                />
            ) : <img
                src="/buiha.png"
                alt=""
                className="md:h-48 md:w-48 xxs:h-40 xxs:w-40 h-32 w-32 max-lg2:mr-4 bannerL grayscale opacity-10"
            />}

            {/* Information section container- Club name and other info*/}
            {name && (
                <div className="flex flex-col justify-left items-left xxs:mx-4">
              {/* Club name*/}
              <h1 className="xxs:text-3xl text-2xl xs:text-4xl pb-1 text-white font-semibold leading-tight pr-1">
                {name}
              </h1>

              {/* Rink, estd, members info container */}
              <div className="hidden md:flex flex-col justify-left items-left pb-2">
                {/* Rink */}
                <div className="flex flex-row justify-left items-centre mb-0.5">
                  <img
                    src="/assets/location.webp"
                    alt="Trophy"
                    style={{ filter: "brightness(0) invert(1)" }}
                    className="w-5 h-6 ml-0.5 mr-2.5"
                  />
                  <p className="text-xl text-white leading-tight ">{home}</p>
                </div>
                {/* Estd. */}
                <div className="flex flex-row justify-left items-centre mb-0.5">
                  <img
                    src="/assets/founded.webp"
                    alt="Trophy"
                    style={{ filter: "brightness(0) invert(1)" }}
                    className="w-6 h-6 mr-2"
                  />
                  <p className="text-xl text-white leading-tight ">
                    Established {founded}
                  </p>
                </div>
                {/* Members */}
                {gbu ? null : (
                  <div className="flex flex-row justify-left items-centre mb-0.5">
                    <img
                      src="/assets/person.webp"
                      alt="Trophy"
                      style={{ filter: "brightness(0) invert(1)" }}
                      className="w-6 h-6 mr-2"
                    />
                    <p className="text-xl text-white leading-tight ">
                      {members} Members
                    </p>
                  </div>
                )}
              </div>

              {/* Socials Links */}
              <div className="flex my-1 md:my-0 flex-row justify-left items-left logos">
                {" "}
                {/* TODO Own Website Twitch TikTok Linktree? */}
                {ig ? (
                  <a
                    href={`https://instagram.com/${ig}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="/instagram.png"
                      alt="Instagram"
                      className="w-6 h-6 xxs:h-8 xxs:w-8 mr-2"
                    />
                  </a>
                ) : null}
                {fb ? (
                  <a
                    href={`https://facebook.com/${fb}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="/facebook.png"
                      alt="Facebook"
                      className="w-6 h-6 xxs:h-8 xxs:w-8 mr-2"
                    />
                  </a>
                ) : null}
                {tw ? (
                  <a
                    href={`https://twitter.com/${tw}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="/twitter.png"
                      alt="Twitter"
                      className="w-6 h-6 xxs:h-8 xxs:w-8 mr-2"
                    />
                  </a>
                ) : null}
                {yt ? (
                  <a
                    href={`https://youtube.com/${yt}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="/youtube2.png"
                      alt="YouTube"
                      className="w-6 h-6 xxs:h-8 xxs:w-8 mr-2"
                    />
                  </a>
                ) : null}
                {web ? (
                  <a href={`${web}`} target="_blank" rel="noreferrer">
                    <img
                      src="/web4.png"
                      alt="Website"
                      className="w-6 h-6 xxs:h-8 xxs:w-8 mr-2"
                    />
                  </a>
                ) : null}
              </div>
            </div>)}
          </div>

          {/* Tab switch buttons */}
          {gbu ? null : (
            <div className="flex flex-row max-lg2:justify-center max-lg2:items-center lg2:justify-left lg2:items-left bannerButtons">
              {visibleTabs.map((tab, idx) => (
                <TabButton
                  key={tab.tabName}
                  tabName={tab.tabName}
                  activeTab={activeTab}
                  handleTabClick={handleTabClick}
                  label={tab.label}
                  first={tab.first}
                />
              ))}
              {overflowTabs.length > 0 && (
                <TabButtonDropdown
                label="More"
                tabs={overflowTabs}
                activeTab={activeTab}
                handleTabClick={handleTabClick}
              />
              )}
            </div>
          )}
        </div>

        {/* Right side rink image */}
        {img?.rink && (
        <div
          className="hidden lg2:flex h-60 w-[480px] bannerR"
          style={{
            backgroundImage: img?.rink
            ? `url(${img.rink})`
            : `url("https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fdesignshack.net%2Fwp-content%2Fuploads%2Fplacehold.jpg&f=1&nofb=1&ipt=82db825f9bfdbd4d9d830f0c656334f16a0cf4a6950a812db7d1b4473848bbe0&ipo=images")`,
          }}
        >

          {img?.rink && (
          <ImageContainer src={img.rink} alt={home} />)
          }
        </div>)}
      </div>
    </div>
  );
};

export default ClubBanner;
